<!--
  * @Descripttion: 添加控销品种
  * @version: V1.6.4
  * @Author: zhangwenxia
  * @Date: 2021-07-21
  -->
<template>
	<div class="container">
		<!--顶部-->
		<iHeader />
		<!--导航-->
		<iNav />
		<!--分类-->
		<iClassify AllActive ref="iClassify" />
		<!--文字提示-->
		<div class="tips">
			<div class="tips-main">
				<h4>添加控销品种</h4>
				<p class="flex align-items-center">
					<van-icon style="color: red" :name="require('@/assets/mine/tips-icon.png')" size="14px" />
					下单购进，即可拥有该商品控销权
				</p>
			</div>
		</div>
		<!--主商品展示区域-->
		<div style="background: #F3F5F7">
			<div class="goods-main">
				<!--搜索条件-->
				<div class="search-box flex flex-column-align-lr align-items-center">
					<div class="sort-box flex align-items-center">
						<p class="sort flex align-items-center justify-content-center" @click="hasClassMain ? (hasClassMain = false) : (hasClassMain = true)">
							<span style="margin-right: 3px">分类</span>
							<van-icon :name="require('@/assets/mine/cate.png')" size="14px" />
						</p>
						<p class="sort flex align-items-center justify-content-center" @click="handleFilter(1)">
							<span>价格</span>
							<i style="margin-left: 0px" class="el-icon-sort-down ml05" :class="{ active: searchParams.sortType === 1 && !searchParams.isSortAsc }"></i>
							<i style="margin-left: -8px" class="el-icon-sort-up" :class="{ active: searchParams.sortType === 1 && searchParams.isSortAsc }"></i>
						</p>
						<p class="sort flex align-items-center justify-content-center" @click="handleFilter(3)">
							<span>销量</span>
							<i style="margin-left: 0px" class="el-icon-sort-down ml05" :class="{ active: searchParams.sortType === 3 && !searchParams.isSortAsc }"></i>
							<i style="margin-left: -8px" class="el-icon-sort-up" :class="{ active: searchParams.sortType === 3 && searchParams.isSortAsc }"></i>
						</p>
					</div>
					<div>
						<el-input class="custom-input" v-keyup="{ delay: 500, fn: handleInputFilter }" v-model="searchParams.keyword" size="small" placeholder="请输入商品名称">
							<div class="search-icon" slot="prefix"><van-icon :name="require('@/assets/mine/search.png')" size="14px" /></div>
						</el-input>
					</div>
				</div>
				<!--分类列表-->
				<div class="class-box mt25" v-if="classList.length && hasClassMain">
					<div class="class-cell">
						<div class="class-item" v-for="(item, index) in classList" @click.stop="handleSelect(item, 1)" :class="{ active: firstClass.Id == item.Id }" :key="index">
							{{ item.ClassifyName }}
						</div>
					</div>
					<div class="class-cell two-f" v-if="firstClass.Children && firstClass.Children.length">
						<div
							class="class-item"
							v-for="(item, index) in firstClass.Children"
							@click.stop="handleSelect(item, 2)"
							:class="{ active: twoClass.Id == item.Id }"
							:key="index"
						>
							{{ item.ClassifyName }}
						</div>
					</div>
				</div>
				<!-- 商品列表-->
				<div class="goods-box mt25">
					<div class="search-listbox flex-row">
						<div class="goods-list-box flex flex-row">
							<!--todo  后期调用组件-->
							<div v-for="(item, index) in dataList" :key="index" class="goods-item">
								<div class="pd-box">
									<div class="goods-img-box" @click.stop="handleDetail(item)">
										<!--商品图片-->
										<div class="goods-img">
											<img
												class="goods-pic"
												:data-src="`${item.Logo}?t=${new Date().getTime()}`"
												src="http://iph.href.lu/200x200?text=图片加载中..."
												alt=""
											/>
										</div>
										<!--商品控销释放时间-->
										<!--根据时间远近显示不同的 class-->
										<!--<div class="goods-class default">-->
										<!--    <p class="ellips-text">距控销释放还剩：30天</p>-->
										<!--</div>-->
										<!--<div class="goods-class hint">-->
										<!--    <p class="ellips-text">距控销释放还剩：3天</p>-->
										<!--</div>-->
										<!--<div class="goods-class warning">-->
										<!--    <p class="ellips-text">已过释放期，7天后将失去控销权</p>-->
										<!--</div>-->
									</div>
									<!-- 商品信息-->
									<div class="goods-info mt10">
										<div class="tag-box">
											<!-- 医保标签标签 -->
											<div
												style="font-size: 0;margin-right: 4px;"
												v-for="properties in item.CommodityListProperties"
												:key="properties.Id"
												v-if="properties.AttributeName == '医保类型'"
											>
												<img v-if="properties.Value == 1" src="@/assets/goods/class_a.png" width="28px" height="16px" />
												<img v-if="properties.Value == 2" src="@/assets/goods/class_b.png" width="28px" height="16px" />
												<img v-if="properties.Value == 3" src="@/assets/goods/yibao.png" width="28px" height="16px" >
											</div>
											<!-- 商品标签 -->
											<!-- <div class="goods-tag tag-spe" v-if="GoodsTags.length">{{ GoodsTags[0].Name }}</div> -->
											<img v-if="item.GoodsTags && item.GoodsTags.length" :src="item.GoodsTags[0].Img" style="width: 32px;height: 16px;margin-right: 4px;" />
											<div class="goods-name ellips-text" @click.stop="handleDetail(item)">{{ item.SkuName }}</div>
										</div>
										
										<div class="goods-msg-item ellips-text" @click.stop="handleDetail(item)">规格：{{ item.Specifications + '/' + item.Unit }}</div>
										<template v-for="properties in item.CommodityListProperties">
											<div class="goods-msg-item ellips-text" :key="properties.Id" v-if="properties.Abbreviation !== '厂' && properties.AttributeName != '医保类型'" @click.stop="handleDetail(item)">
												{{ properties.Abbreviation === '效' ? '效期优于：' + properties.Value : properties.Value }}
											</div>
										</template>
										<div class="goods-price" v-if="!item.IsOutBusinessScope" @click.stop="handleDetail(item)">
											<template v-if="item.PriceActivity">
												<span class="old-money" v-if="item.IsShowOriginalPrice && item.SourceGoodsSkuId">¥ {{ item.Price }}</span>
												<div class="new-money">
													<span class="text">优惠价</span>
													<span class="value">¥ {{ item.PriceActivity.toFixed(2) }}</span>
												</div>
											</template>
											<span class="money" v-else>¥ {{ item.PriceLimit }}</span>
										</div>
										<div class="goods-disc" v-if="!item.IsOutBusinessScope" @click.stop="handleDetail(item)">
											<span>
												最低零售价 ¥{{ Number(item.RetailPrice).toFixed(2) }} | 毛利率
												{{ _showProductProfit(item.RetailPrice, _getProductPrice(item.PriceActivity, item.PriceLimit)) + '%' }}
											</span>
										</div>
										<div class="goods-bottom flex align-items-center">
											<div style="flex:1">
												<van-stepper
													v-model="item.cartNum"
													:min="item.OutPurchaseAgreementDto.PurchaseNumber"
													:disable-plus="item.cartNum >= item.Stock || (item.LimitPerOrder && item.cartNum >= item.LimitPerOrder)"
													:step="item.OutPurchaseAgreementDto.StepLengthNumber"
													integer
												/>
											</div>
											<div><a-button type="primary" class="join-btn" @click="addCart(item)">加入购物车</a-button></div>
										</div>
									</div>
									<!-- 商品信息END-->
								</div>
							</div>
						</div>
					</div>
					<!-- 分页 -->
					<iPagination
						:currentPage.sync="page.pageIndex"
						:limit.sync="page.pageSize"
						:totalCount="page.pageCont"
						@turn="onLoad"
						v-if="dataList && dataList.length"
						small
					/>
					<!-- 空数据占位层 -->
					<EmptyControl style="padding: 100px 0;" v-if="dataList && !dataList.length" type="goods" text="暂无相关商品"></EmptyControl>
				</div>
			</div>
		</div>
		<!--购物车结算区域-->
		<router-link :to="LinkTypeCode.BuyCar">
			<div class="submit">
				<div class="submit-main flex align-items-center flex-column-align-lr">
					<div class="selected-box">
						<!-- <h4>已选品种({{ carCount > 99 ? '99+' : carCount }})</h4> -->
						<p>
							<i class="el-icon-warning-outline"></i>
							结算付款后，完成控销权确认
						</p>
					</div>
					<div class="submit-buy-cart">去购物车结算</div>
				</div>
			</div>
		</router-link>
		<!--右侧边栏-->
		<iRightFixedBox />
		<!--底部-->
		<iFooter />
	</div>
</template>

<script>
import iHeader from '@/components/Header';
import iNav from '@/components/Nav';
import iClassify from '@/components/Classify';
import iRightFixedBox from '@/components/RightFixedBox';
import iFooter from '@/components/Footer';
import { throttle, lazyLoad } from '@/utils/util';
import { LinkTypeCode } from '../../dictionary/base.js';
import moment from 'moment';
import { BaseMixin } from '@/mixins/BaseMixin';

export default {
	name: 'AddControlPinKind',
	components: { iHeader, iNav, iClassify, iRightFixedBox, iFooter },
	data() {
		return {
			LinkTypeCode,
			dataList: [],
			searchParams: {
				operatingClassifyId: '', //分类ID
				sortType: 0, //价格1，销量3
				isSortAsc: false, //是否正序排列，正序true，倒序false
				keyword: '', //关键字
				IsOnlyGoodsControl: true //只查询控销商品
			},
			// 购物车数量
			carCount: 0,
			// 分类列表
			classList: [],
			// 已选中的第一级分类
			firstClass: {},
			// 已选中的第二级分类
			twoClass: {},
			// 分类菜单展示标记
			hasClassMain: false,
			// 分页对象
			page: {
				pageIndex: 1,
				pageSize: 10,
				pageCont: 0
			}
		};
	},
	mixins: [BaseMixin],
	mounted() {
		this.getClassMenu();
		this.onLoad();
	},
	methods: {
		/**
		 * 条件查询，排序过滤
		 * @param {integer} e: 1按价格  3按销量
		 */
		handleFilter(e) {
			// 保存查询正序/倒序值
			this.searchParams.isSortAsc ? (this.searchParams.isSortAsc = false) : (this.searchParams.isSortAsc = true);
			// 保存查询类型
			this.searchParams.sortType = e;
			// 初始化分页
			this.initPage();
			// 刷新列表
			this.onLoad();
		},
		/**
		 *  关键字模糊查询
		 */
		handleInputFilter() {
			// 初始化分页
			this.initPage();
			// 刷新列表
			this.onLoad();
		},
		/**
		 *  初始化分页
		 */
		initPage() {
			// 初始化分页
			this.page = {
				pageIndex: 1,
				pageSize: 10,
				pageCont: 0
			};
		},
		/**
		 *  获取列表数据
		 */
		onLoad() {
			this.getAction('/api_goods/GoodsSku/ListForCustomer', {
				...this.searchParams,
				pageindex: this.page.pageIndex,
				pagesize: this.page.pageSize
			}).then(res => {
				if (!res.IsSuccess) {
					this.$toast({ position: 'bottom', message: res.Msg });
					return;
				}
				// 保存数据总条数
				this.page.pageCont = res.Count;

				// 给每一条数据都追加一个临时变量，用于保存当前选中数量
				this.dataList = res.Data.map(item => {
					return {
						...item,
						cartNum: item.OutPurchaseAgreementDto.PurchaseNumber
					}
				})
				
				this.$nextTick(() => {
					lazyLoad('.goods-pic');
				});

				// if (res.Data.length === 0) {
				// 	this.dataList = [];
				// } else {
				// 	// 给每一条数据都追加一个临时变量，用于保存当前选中数量
				// 	res.Data.forEach(item => {
				// 		this.dataList.push({
				// 			...item,
				// 			cartNum: item.OutPurchaseAgreementDto.PurchaseNumber
				// 		});
				// 	});
				// 	// 本地数据集合通过ID去重
				// 	this.dataList = this.dataList.filter(function(element, index, self) {
				// 		return self.findIndex(el => el.Id == element.Id) === index;
				// 	});
				// 	this.$nextTick(() => {
				// 		lazyLoad('.goods-pic');
				// 	});
				// }
			});
		},
		/**
		 * 查询分类信息
		 */
		async getClassMenu() {
			let res = await this.getAction('/api_goods/OperatingClassify/GetListOwner', { IsOnlyGoodsControl: true });
			if (res.IsSuccess) {
				this.classList = res.Data;
			}
		},
		/**
		 * 条件查询，分类点击
		 * @param {object} item: 当前点击的分类对象
		 * @param {integer} val: 点击层级, 1第一层  2第二层
		 */
		handleSelect(item, val) {
			// 第一层
			if (val === 1) {
				// 已存在过滤条件
				if (this.searchParams.operatingClassifyId !== '') {
					// 点击其他同级的过滤条件
					if (this.searchParams.operatingClassifyId !== item.Id) {
						// 在已选择第一级和第二级的前提下，点击其他第一级分类
						if (this.searchParams.operatingClassifyId === this.twoClass.Id && item.Id === this.firstClass.Id) {
							// 清空缓存
							this.searchParams.operatingClassifyId = '';
							this.firstClass = {};
							this.twoClass = {};
						} else {
							// 缓存点击对象
							this.firstClass = item;
							// 清空二级缓存
							this.twoClass = {};
							// 保存查询ID
							this.searchParams.operatingClassifyId = item.Id;
						}
					} else {
						// 清空缓存
						this.searchParams.operatingClassifyId = '';
						this.firstClass = {};
						this.twoClass = {};
					}
				} else {
					// 不存在过滤条件
					// 缓存点击对象
					this.firstClass = item;
					// 保存查询ID
					this.searchParams.operatingClassifyId = item.Id;
				}
			}
			// 第二层
			if (val === 2) {
				// 已存在过滤条件
				if (this.searchParams.operatingClassifyId !== '') {
					// 点击其他同级的过滤条件
					if (this.searchParams.operatingClassifyId !== item.Id) {
						// 保存第二层缓存
						this.twoClass = item;
						// 保存查询ID
						this.searchParams.operatingClassifyId = item.Id;
					} else {
						// 清空缓存
						this.searchParams.operatingClassifyId = this.firstClass.Id;
						this.twoClass = {};
					}
				} else {
					// 不存在过滤条件
					// 保存第二层缓存
					this.twoClass = item;
					// 保存查询ID
					this.searchParams.operatingClassifyId = item.Id;
				}
			}
			// 初始化筛选条件
			this.searchParams.isSortAsc = false;
			this.searchParams.sortType = 0;
			// 初始化分页
			this.initPage();
			// 刷新列表
			this.onLoad();
		},
		/*
		 * 跳转详情
		 * @param {object} item: 商品对象
		 */
		handleDetail(item) {
			this._jump(
				this.Enum_LinkTypeCode.ProductDetails,
				{
					id: item.Id,
					detailType: item.SourceGoodsSkuId ? 'specialOffer' : '',
					configType: item.GoodsType !== 3 ? '' : '', // 暂留
					ruleText: item.RuleText || ''
				},
				'_blank'
			);
		},
		/*
		 * 加入购物车
		 * @param {object} e: 商品对象
		 */
		async addCart(e) {
			// 判断是否超出限购
			if (!!e.LimitPerOrder && e.cartNum > e.LimitPerOrder) {
				this.$toast({
					position: 'bottom',
					message: '单笔订单限购（' + e.LimitPerOrder + '）' + e.Unit
				});
				return;
			}
			// 判断是否超出库存
			if (e.cartNum > e.Stock) {
				this.$toast({
					position: 'bottom',
					message: '购买商品数量超过了该商品库存，库存余（' + e.Stock + '）'
				});
				e.cartNum = e.Stock;
				return;
			}
			// 基础验证通过,调用接口
			let res = await this.postAction('/api_order/ShoppingCarts/AddOrUpdateCart', {
				ProductSKUId: e.Id,
				Count: e.cartNum,
				IsAdd: true,
				SourceGoodsSkuId: e.SourceGoodsSkuId,
				IsPrice: false
			});
			if (res.IsSuccess) {
				this.$nextTick(() => {
					if (res.Data.CountData) {
						// 判断是否可以加购
						if (res.Data.IsLimitPerOrder) {
							this.$toast({
								position: 'bottom',
								message: '单笔订单限购（' + e.LimitPerOrder + '）' + e.Unit
							});
							return false;
						}
						// 更新nav和右侧悬浮 购物车数量
						this.$bus.$emit('buycarChanged', res.Data.CountData.ProductCount, true);
						this.$bus.$emit('rightBuycarChanged', res.Data.CountData.ProductCount, true);
					}
					this.$toast({
						position: 'center',
						message: '添加购物车成功'
					});
				});
			} else {
				this.$toast({ position: 'bottom', message: res.Msg });
			}
		}
	}
};
</script>

<style lang="less" scoped>
.active {
	color: #0f6ee9 !important;
}

/deep/ .van-stepper__minus {
	background: #fff;
	border-radius: 2px 0px 0px 2px;
	border: 1px solid #c5cad5;
}

/deep/ .van-stepper__input {
	border-top: 1px solid #c5cad5;
	border-bottom: 1px solid #c5cad5;
	background: #fff;
	margin: 0;
}

/deep/ .van-stepper__plus {
	border-radius: 0 2px 2px 0;
	border: 1px solid #c5cad5;
	background: #fff;
}

/deep/ .custom-input input {
	width: 360px;
	background: #fff;
	color: #858b9c;
}

/deep/ .custom-input .el-input__prefix {
	display: flex;
	align-items: center;
	margin-left: 5px;
}

/deep/ .new-money {
	height: 20px;
	background: linear-gradient(137deg, #ff6831 0%, #f3180e 100%);
	border-radius: 4px;
	color: #fff;
	line-height: 20px;
	display: flex;
	align-items: center;
	padding: 0 6px;
}

/deep/ .goods-price {
	margin-top: 10px;
	display: flex;
}
/deep/ .old-money {
	color: #858b9c;
	text-decoration: line-through;
	margin-right: 8px;
}

.class-box {
	width: 100%;
	background: #fff;
}

.class-cell {
	display: flex;
	flex-wrap: wrap;
	padding: 15px;
	padding-bottom: 0;
}

.two-f {
	border-top: 1px solid #eee;
}

.class-item {
	margin-right: 15px;
	cursor: pointer;
	margin-bottom: 15px;
	line-height: 1;
}

.class-cell .active {
	color: #0f6eea;
}

.class-item:hover {
	color: #0f6eea;
}

.container {
	.tips {
		background: #ff3939;
		height: 62px;
		color: white;

		.tips-main {
			width: 1200px;
			margin: auto;
			position: relative;

			h4 {
				margin: 0;
				color: white;
				text-align: center;
				font-size: 20px;
				line-height: 62px;
				font-weight: 500;
			}

			p {
				margin: 0;
				position: absolute;
				right: 0px;
				top: 20px;
				font-size: 14px;
				font-weight: 400;

				i {
					margin-right: 5px;
				}
			}
		}
	}

	.goods-main {
		width: 1200px;
		margin: auto;
		padding: 25px 0;

		.search-box {
			.sort-box {
				border-radius: 2px;
				border: 1px solid #c5cad5;
				height: 30px;
				line-height: 30px;
				overflow: hidden;

				.sort {
					cursor: pointer;
					margin: 0;
					text-align: center;
					width: 94px;
					background: #fff;
					border-right: 1px solid #c5cad5;

					span {
						font-size: 14px;
						font-weight: 400;
						color: #111a34;
					}

					&:last-child {
						border-right: none;
					}

					i {
						font-weight: 600;
						font-size: 14px;
						color: #444;
						cursor: pointer;
					}
				}
			}
		}

		.goods-list-box {
			flex-wrap: wrap;
			max-width: 1200px;
			position: relative;

			.goods-item {
				box-sizing: border-box;
				border-radius: 2px;
				border: 1px solid #edecec;
				width: 230px;
				margin: 0 12px 16px 0;
				background: #fff;
				cursor: pointer;

				&:nth-child(5n) {
					margin-right: 0;
				}

				.pd-box {
					border-radius: 2px;
					box-sizing: border-box;
					padding: 8px;
					width: 100%;
					text-align: left;
					height: 100%;

					&:hover {
						.goods-pic {
							transform: scale(1.05);
						}
					}

					.goods-img-box {
						position: relative;
						width: 100%;
						height: 200px;
						background: #f3f5f8;
						overflow: hidden;

						.goods-img {
							width: 100%;
							height: 200px;
							display: flex;
							align-items: center;
							justify-content: center;

							.goods-pic {
								width: 100%;
								height: 100%;
								transition: all 0.6s;
							}
						}

						.goods-class {
							width: 100%;
							height: 28px;
							border-radius: 8px 8px 0px 0px;
							position: absolute;
							z-index: 1;
							left: 0;
							bottom: 0;
							line-height: 28px;
							padding: 0 10px;
							box-sizing: border-box;
							color: #fff;
							font-size: 12px;

							&.default {
								background: #666f83;
							}

							&.hint {
								background: #ff7575;
							}

							&.warning {
								background: #ff3939;
							}
						}
					}

					.goods-info {
						.tag-box{
							display: flex;
							align-items: center;
						}
						.goods-name {
							font-size: 16px;
							font-weight: 600;
							color: #111a34;
						}

						.goods-msg-item {
							font-size: 14px;
							font-weight: 500;
							color: #666f83;
							margin-top: 4px;
							line-height: normal;
						}

						.goods-price {
							margin-top: 10px;

							.money {
								color: #ff3939;
								font-size: 20px;
								margin-right: 8px;
								font-family: Avenir-Heavy, Avenir;
								font-weight: 800;
							}
						}

						.goods-disc {
							color: #666f83;
							font-size: 12px;
							margin-top: 4px;
						}

						.goods-bottom {
							margin-top: 14px;

							.join-btn {
								background: #f60707;
								border-radius: 2px;
								width: 85px;
								height: 28px;
								padding: 0 8px;
								border-color: #f60707;
							}

							.join-btn-ready {
								border-radius: 2px;
								width: 85px;
								height: 28px;
								padding: 0 8px;
							}
						}
					}
				}
			}
		}
	}

	.submit {
		position: sticky;
		bottom: 0;
		height: 100px;
		background: #fff;
		transition: all 0.3s;
		z-index: 10;

		.submit-main {
			width: 1200px;
			height: 100px;
			margin: auto;

			.selected-box {
				text-align: left;

				h4 {
					margin: 0;
					font-size: 20px;
					font-weight: 500;
					color: #111a34;
				}

				p {
					margin: 10px 0 0 0;
					font-size: 14px;
					font-weight: 400;
					color: #0f6eea;

					i {
						margin-right: 5px;
					}
				}
			}

			.submit-buy-cart {
				cursor: pointer;
				width: 224px;
				height: 88px;
				line-height: 88px;
				background: #ff3939;
				border-radius: 8px;
				font-size: 24px;
				font-weight: 500;
				color: #fff;
				opacity: 1;
				transition: opacity 0.5s;

				&:hover {
					opacity: 0.8;
				}
			}
		}
	}
}
</style>
